import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import { ONBOARDING_BRIEF_QUIZ_CONTENT as Content } from 'app/constants/onBoarding'
import { IOnboardingBriefQuizProps } from './interface'

import './style.scss'
export const bc = 'onboarding-brief-quiz'

class OnboardingBriefQuiz extends Component<IOnboardingBriefQuizProps> {
  maybeLaterHandler = () => {
    const { isPostSurvey } = this.props
    this.props.hideModal()
    this.props.requestSurvey({ isPostSurvey, sendEmail: true })
  }

  render() {
    const {
      t,
      i18n: { language },
      showTypeFormPopup,
      surveyData,
    } = this.props
    return (
      <div className={`${bc}`}>
        <div className={`${bc}__title`}>{t('Brief Quiz')}</div>
        <div className={`${bc}__content`}>
          <p className={`${bc}__text`}>
            {t(
              'Take this 2 minute quiz for a quick snapshot of your current habits so you can track your progress later.'
            )}
          </p>
          <div className={`${bc}__img`}>
            <img src={Content.src} alt={Content.src} />
          </div>
          <p className={`${bc}__quote-text`}>“{t(Content.quote)}”</p>
          <div className={`${bc}__quote-author`}>{Content.quoteAuthor}</div>
        </div>

        <div
          className={cn(`${bc}__buttons`, {
            [`${bc}__buttons__${language}`]: language,
          })}
        >
          <Button
            primary
            className={`${bc}__btn ${bc}__btn--quiz`}
            onClick={showTypeFormPopup}
            disabled={!surveyData}
            submitting={!surveyData}
          >
            {t('Next')}
          </Button>
          <Button className={`${bc}__btn ${bc}__btn--later`} onClick={this.maybeLaterHandler}>
            {t('Maybe Later')}
          </Button>
        </div>
      </div>
    )
  }
}

export default withTranslation('user')(OnboardingBriefQuiz)
